import { useMutation } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import useUserLayoutPreferences from "components/common/EntityDataTable/hooks/useUserLayoutPreferences";
const preferencesToJSON = ({
  attributes,
  sort,
  perPage,
  customPreferences,
  order
}) => ({
  attributes,
  sort: sort ? { order: sort.direction, field: sort.attributeId } : void 0,
  per_page: perPage,
  custom_preferences: customPreferences,
  order
});
const useUpdateUserLayoutPreferences = (entityTableId) => {
  const { data: userLayoutPreferences = {}, refetch } = useUserLayoutPreferences(entityTableId);
  const mutationFn = (newPreferences) => fetch(
    "POST",
    qualifyUrl(`/entitylists/preferences/${entityTableId}`),
    preferencesToJSON({ ...userLayoutPreferences, ...newPreferences })
  );
  const { mutateAsync } = useMutation({
    mutationFn,
    onError: (error) => {
      UserNotification.error(`Updating table layout preferences failed with error: ${error}`);
    },
    onSuccess: () => refetch()
  });
  return { mutateAsync };
};
export default useUpdateUserLayoutPreferences;
